export default {
    state: {
        fields: {
            'start-date': null,
            'end-date': null,
            'event-category': null,
            'event-audience': null,
            'search': null,
        },
        loadingStatus: {
            'event-category': true,
            'event-audience': true,
            'calendar': false,
        }
    },
    mutations: {
        updateField(state, field) {
            state.fields[field.name]= field.value;
        },
        updateLoadingStatus(state, newLoadingStatus) {
            state.loadingStatus[newLoadingStatus.name] = newLoadingStatus.status
        }
    },
    getters: {
        endDate(state) {
            return state.fields['end-date']
        },
        startDate(state) {
            return state.fields['start-date']
        },
        loadingStatus(state) {
            return (!(state.loadingStatus['event-category'] === false && state.loadingStatus['event-audience'] === false && state.loadingStatus['calendar'] === false))
        },
        allFields(state) {
            let fieldValues = state.fields
            return Object.keys(fieldValues)
                .filter((k) => fieldValues[k] != null)
                .reduce((a, k) => ({ ...a, [k]: fieldValues[k] }), {});
        }

    }
}
